import {
  CheckCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  EditOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Col, DatePicker, Row } from "antd";
import { Input } from "antd";
import { Tooltip } from "antd";
import { Form } from "antd";
import dayjs from "dayjs";
import React, { FC } from "react";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../../../utils/notificationUtils";
import { Button } from "antd";
import { Spin } from "antd";
import { Badge } from "antd";
import CommunicationAddress from "../CghsNewTabs/CommunicationAddress";
import PatientAttendantDetails from "../CghsNewTabs/PatientAttendantDetails";

type PortalRegistrationAyushmanProps = {
  form: any;
  editRegId: boolean;
  handleEditRegId: any;
  handleSubmitId: any;
  handleRegistration: any;
  portalData: any;
  handlePreviewDocument: any;
  cardDocumentUrl: any;
  showRegistrationId?: boolean;
  registrationValidationStatus: any;
  isValidationLoading?: boolean;
  showVerifyButton?: boolean;
  handleRegistrationValidation?: any;
  handleOTPVerification?: any;
  handleMobileVerification?: any;
  otpVerificationForm?: any;
  isMobileNumberVerified?: boolean;
  isOTPVerified?: boolean;
  isOTPVerificationLoading?: boolean;
  handleRegister?: any;
  isRegisterLoading?: boolean;
  openRegistrationForm?: boolean;
  isPortalRegistrationSuccess?: boolean;
  patientResponse?: any;
};

const PortalRegistrationAyushman: FC<PortalRegistrationAyushmanProps> = ({
  form,
  editRegId,
  handleEditRegId,
  handleRegistration,
  handleSubmitId,
  portalData,
  handlePreviewDocument,
  cardDocumentUrl,
  showRegistrationId,
  registrationValidationStatus,
  isValidationLoading,
  showVerifyButton,
  handleRegistrationValidation,
  handleOTPVerification,
  handleMobileVerification,
  otpVerificationForm,
  isMobileNumberVerified,
  isOTPVerified,
  isOTPVerificationLoading,
  handleRegister,
  isRegisterLoading,
  openRegistrationForm,
  isPortalRegistrationSuccess,
  patientResponse,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const handleUpdateId = async () => {
    try {
      const values = await form.validateFields();
      await handleSubmitId(values);
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please fill all details before submitting");
      } else {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    }
  };

  const handleSubmit = async () => {
    await handleRegistration();
  };

  const onRegisterClicked = async () => {
    try {
      await form.validateFields();
      handleRegister();
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please fill all details before submitting");
      } else {
        errorMessage(err?.response?.data || "Please, Try again after sometime");
      }
    }
  };

  const styles: Record<string, React.CSSProperties> = {
    mainContent: {
      //   border: "0.4px solid rgb(87, 87, 87)",
      gap: "15px",
      borderRadius: "16px",
      margin: "0px 0.5rem",
    },
    statusDesign: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "20px",
      minWidth: "676px",
      maxHeight: "36px",
    },
    borderDesign: {
      minHeight: "64px",
      background: "rgb(243, 243, 243)",
      padding: "12px 35px", // Removed the semicolon and fixed the gap
      gap: "42px", // Added the gap as a separate property
      borderRadius: "16px 16px 0px 0px", // Fixed camelCase
      borderBottom: "1px solid rgb(166, 166, 166)",
      fontWeight: "600",
      fontSize: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    filledBtn: {
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      textTransform: "uppercase",
      color: "white",
      marginRight: "0.8rem",
    },
    blankBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      marginRight: "0.8rem",
    },
    updateBtn: {
      position: "sticky",
      top: 0,
      backgroundColor: "white",
      zIndex: 998,
      padding: "10px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    intimateSubmitBtn: {
      background: "#008B8B",
      // float: "right",
      marginRight: "0.8rem",
    },
    saveBtn: {
      color: "white",
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
    editBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
  };

  return (
    <div style={{ marginTop: "-23px", position: "relative" }}>
      <Spin
        size="large"
        spinning={isValidationLoading}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 10,
        }}
      />
      <div
        style={{
          opacity: isValidationLoading ? 0.5 : 1,
          transition: "opacity 0.3s",
        }}
      >
        <Form
          form={form}
          onFinish={handleSubmit}
          labelAlign="left"
          layout="vertical"
          labelWrap
          style={{ width: "100%" }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={7} lg={7} xl={7}>
              <Form.Item
                label="BENEFICIARY ID"
                name="beneficiaryId"
                style={{ marginTop: "1.7rem" }}
                rules={[
                  {
                    required: true,
                    message: "Please input BENEFICIARY ID",
                  },
                ]}
              >
                <Input
                  placeholder="Please input BENEFICIARY ID"
                  disabled={portalData?.schemeRegistrationId}
                  style={{ color: "black" }}
                />
              </Form.Item>
            </Col>

            {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
              <Form.Item
                label="REGISTRATION DATE"
                name="registrationDate"
                style={{ marginTop: "1.7rem", color: "black" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Registration Date",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format={dateFormat}
                  disabled={portalData?.schemeRegistrationId}
                  disabledDate={(current) => {
                    const now = dayjs().endOf("day");
                    const firstAllowedDate = dayjs().startOf("year");

                    return (
                      current.isBefore(firstAllowedDate, "day") ||
                      current.isAfter(now, "day")
                    );
                  }}
                />
              </Form.Item>
            </Col> */}

            {/* {!portalData?.schemeRegistrationId ? <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                <Form.Item
                  label="REGISTRATION ID"
                  name="registrationId"
                  style={{ marginTop: "1.7rem", color: "black" }}
                  rules={[
                    {
                      required: true,
                      message: "Please input REGISTRATION ID",
                    },
                    {
                      pattern: /^\S+$/,
                      message: "REGISTRATION ID must not contain spaces",
                    },
                  ]}
                >
                  <Input
                    placeholder="Please input REGISTRATION ID"
                    disabled={portalData?.schemeRegistrationId}
                    style={{ color: "black" }}
                  />
                </Form.Item>
              </Col> : <></>} */}

            {portalData?.schemeRegistrationId || showRegistrationId ? (
              !editRegId ? (
                <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                  <Form.Item
                    // label="REGISTRATION ID"
                    label={
                      <span>
                        REGISTRATION ID{" "}
                        {registrationValidationStatus && (
                          <Badge
                            count={
                              registrationValidationStatus?.toUpperCase() ===
                              "FAILED"
                                ? "Not Verified"
                                : registrationValidationStatus?.toUpperCase() ===
                                    "DISCREPANCY"
                                  ? "MISMATCH"
                                  : "Verified"
                            }
                            style={{
                              backgroundColor:
                                registrationValidationStatus?.toUpperCase() ===
                                "VALIDATED"
                                  ? "#52c41a"
                                  : registrationValidationStatus?.toUpperCase() ===
                                      "FAILED"
                                    ? "#f5222d"
                                    : registrationValidationStatus?.toUpperCase() ===
                                        "DISCREPANCY"
                                      ? "#f5222d"
                                      : "#fca800ff",
                            }}
                          />
                        )}
                      </span>
                    }
                    name="registrationId"
                    style={{ marginTop: "1.7rem", color: "black" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input REGISTRATION ID",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Please input REGISTRATION ID"
                      disabled={
                        portalData?.schemeRegistrationId || showRegistrationId
                      }
                      style={{ color: "black" }}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                  <Form.Item
                    label="REGISTRATION ID"
                    name="registrationId"
                    style={{ marginTop: "1.7rem", color: "black" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input REGISTRATION ID",
                      },
                      {
                        pattern: /^\S+$/,
                        message: "REGISTRATION ID must not contain spaces",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Please input REGISTRATION ID"
                      style={{ color: "black" }}
                    />
                  </Form.Item>
                </Col>
              )
            ) : (
              <></>
            )}
            {portalData?.schemeRegistrationId || showRegistrationId ? (
              !editRegId ? (
                <>
                  <input
                    type="text"
                    id="hidden-copy-input"
                    value={portalData?.schemeRegistrationId || "-"}
                    readOnly
                    style={{ position: "absolute", left: "-9999px" }}
                  />

                  <Tooltip title="Copy Registration ID">
                    <CopyOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const hiddenInput: any =
                          document.getElementById("hidden-copy-input");
                        if (hiddenInput) {
                          hiddenInput.select();

                          try {
                            const successful = document.execCommand("copy");
                            if (successful) {
                              successMessage(
                                "Registration ID copied to clipboard!",
                              );
                            } else {
                              errorMessage("Failed to copy Registration ID.");
                            }
                          } catch (err) {
                            errorMessage("Copy command failed!");
                          }
                        } else {
                          warningMessage("No Registration ID to copy!");
                        }
                      }}
                    />
                  </Tooltip>
                  {!portalData?.casePreAuthCghs?.claimId &&
                  registrationValidationStatus?.toUpperCase() !==
                    "VALIDATED" ? (
                    <Tooltip title="Edit Registration ID">
                      <EditOutlined
                        style={{
                          paddingTop: "24px",
                          fontSize: "20px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={handleEditRegId}
                      />
                    </Tooltip>
                  ) : (
                    <></>
                  )}
                  {showVerifyButton ? (
                    <Button
                      color="cyan"
                      type="primary"
                      icon={<CheckCircleOutlined />}
                      loading={isValidationLoading}
                      style={{
                        marginTop: "52px",
                        marginLeft: "14px",
                        cursor: "pointer",
                      }}
                      onClick={handleRegistrationValidation}
                    >
                      {portalData?.portalRegistrationStatus ||
                      registrationValidationStatus
                        ? "View"
                        : "Verify"}
                    </Button>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  <Tooltip title="Cancel Update Registration ID">
                    <CloseOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={handleEditRegId}
                    />
                  </Tooltip>
                  <Tooltip title="Save Registration ID">
                    <CheckOutlined
                      style={{
                        paddingTop: "24px",
                        fontSize: "20px",
                        marginLeft: "8px",
                        cursor: "pointer",
                      }}
                      onClick={handleUpdateId}
                    />
                  </Tooltip>
                </>
              )
            ) : (
              <></>
            )}

            {cardDocumentUrl ? (
              <Col
                xs={24}
                sm={12}
                md={2}
                lg={2}
                xl={2}
                className="card-preview"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span style={{ fontSize: "14px", paddingBottom: "10px" }}>
                  Ayushman Card
                </span>
                <Tooltip title="Preview CGHS Card">
                  <EyeOutlined
                    style={{
                      paddingBottom: "8px",
                      fontSize: "20px",
                      marginLeft: "8px",
                      cursor: "pointer",
                    }}
                    onClick={handlePreviewDocument}
                  />
                </Tooltip>
              </Col>
            ) : (
              <></>
            )}
          </Row>

          {portalData?.schemeRegistrationId ||
          (portalData?.visitStagesName?.toLowerCase()?.toString() ==
            "portal registration" &&
            (portalData?.stateName?.toLowerCase()?.toString() == "initiated" ||
              portalData?.stateName?.toLowerCase()?.toString() == "submitted" ||
              portalData?.stateName?.toLowerCase()?.toString() ==
                "id generated" ||
              portalData?.stateName?.toLowerCase()?.includes("verified") ||
              portalData?.stateName?.toLowerCase()?.toString() ==
                "manually submitted")) ? (
            <></>
          ) : (
            !openRegistrationForm && (
              <Row justify="end" style={{ marginBottom: "0" }}>
                <Form.Item
                  wrapperCol={{ span: 16 }}
                  style={{ marginBottom: "0" }}
                >
                  {
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                      }}
                    >
                      PORTAL REGISTRATION
                    </Button>
                  }
                </Form.Item>
              </Row>
            )
          )}
        </Form>
      </div>
      {openRegistrationForm && (
        <div style={styles.mainContent}>
          <CommunicationAddress form={form} />

          <PatientAttendantDetails
            form={form}
            otpVerificationForm={otpVerificationForm}
            handleOTPVerification={handleOTPVerification}
            handleMobileVerification={handleMobileVerification}
            isMobileNumberVerified={isMobileNumberVerified}
            isOTPVerified={isOTPVerified}
            isOTPVerificationLoading={isOTPVerificationLoading}
            patientResponse={patientResponse}
          />

          <Row justify="center" style={{ marginTop: "20px" }}>
            <div style={{ width: "16%" }}>
              <Button
                loading={isRegisterLoading}
                type="primary"
                style={{
                  backgroundColor: "rgb(0, 76, 143)",
                  color: "#fff",
                  boxShadow: "0px 2px 8px 0px #00000040",
                  width: "100%",
                }}
                onClick={onRegisterClicked}
                disabled={
                  !isOTPVerified ||
                  isPortalRegistrationSuccess ||
                  isRegisterLoading
                }
              >
                Register
              </Button>
            </div>
          </Row>
        </div>
      )}
    </div>
  );
};

export default React.memo(PortalRegistrationAyushman);
